import React from 'react';
import {Link} from 'react-router-dom';
import '../Demo.scss';
import {Box} from '@mui/material';
import ArrFilterAccordion from '../../../components/common/arr-filter-panel/filter-accordion/ArrFilterAccordion';

const dummyFilterData = [
  {
    projectFieldId: '1',
    projectFieldName: 'string',
    dataType: 'NVARCHAR',
    projectFieldLabel: 'CustodianName',
    type: 'string',
    metaDataID: 1,
  },
  {
    projectFieldId: '2',
    projectFieldName: 'string',
    dataType: 'DATETIME',
    projectFieldLabel: 'MasterDate',
    type: 'string',
    metaDataID: 2,
  },
  {
    projectFieldId: '3',
    projectFieldName: 'string',
    dataType: 'INT',
    projectFieldLabel: 'DocFileSize',
    type: 'string',
    metaDataID: 3,
  },
  {
    projectFieldId: '4',
    projectFieldName: 'string',
    dataType: 'NVARCHAR',
    projectFieldLabel: 'EmailAllDomains',
    type: 'string',
    metaDataID: 4,
  },
  {
    projectFieldId: '5',
    projectFieldName: 'string',
    dataType: 'NVARCHAR',
    projectFieldLabel: 'DocFileType',
    type: 'string',
    metaDataID: 5,
  },
  {
    projectFieldId: '6',
    projectFieldName: 'string',
    dataType: 'NVARCHAR',
    projectFieldLabel: 'EmailAuthorName',
    type: 'string',
    metaDataID: 6,
  },
  {
    projectFieldId: '7',
    projectFieldName: 'string',
    dataType: 'NVARCHAR',
    projectFieldLabel: 'EmailRecipientNames',
    type: 'string',
    metaDataID: 7,
  },
  {
    projectFieldId: '8',
    projectFieldName: 'string',
    dataType: 'NVARCHAR',
    projectFieldLabel: 'FilterSelection',
    type: 'string',
    metaDataID: 8,
  },
];
const FilterAccordionDemo: React.FC = () => {
  return (
    <Box className="demo-page modal-demo">
      <h1>Filter Accordion</h1>

      <hr />
      <Link to="/demo" className="link">
        Return
      </Link>
      <hr />
      <h2>Filter Accordion InActive State</h2>
      <Box className="filter-panel">
        <ArrFilterAccordion
          filters={dummyFilterData}
          onFilterChange={() => {}}
          isFilterInactive={true}
          title={'Title'}
        />
      </Box>
      <h2>Filter Accordion Active State</h2>
      <Box className="filter-panel">
        <ArrFilterAccordion
          title={'Title'}
          filters={dummyFilterData}
          onFilterChange={() => {}}
          isFilterInactive={false}
        />
      </Box>
    </Box>
  );
};

export default FilterAccordionDemo;
